/**
 * localStorage helper for Super User simulation state
 * Manages role and organization simulation persistence
 */

const SIMULATION_KEY = 'superUserSimulation';

/**
 * Get current simulation state from localStorage
 * @returns {Object|null} Simulation state or null if not set
 */
export const getSimulation = () => {
  try {
    const data = localStorage.getItem(SIMULATION_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Error reading simulation from localStorage:', error);
    return null;
  }
};

/**
 * Save simulation state to localStorage
 * @param {number|null} simulatedRole - User type (0-3) or null
 * @param {Object|null} simulatedOrg - Organization object {id, name} or null
 */
export const setSimulation = (simulatedRole, simulatedOrg) => {
  try {
    const data = {
      simulatedRole,
      simulatedOrg,
      timestamp: Date.now()
    };
    localStorage.setItem(SIMULATION_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Error saving simulation to localStorage:', error);
  }
};

/**
 * Clear simulation state from localStorage
 */
export const clearSimulation = () => {
  try {
    localStorage.removeItem(SIMULATION_KEY);
  } catch (error) {
    console.error('Error clearing simulation from localStorage:', error);
  }
};

/**
 * Check if simulation is currently active
 * @returns {boolean} True if simulation is active
 */
export const isSimulationActive = () => {
  const simulation = getSimulation();
  return !!(simulation && (simulation.simulatedRole != null || simulation.simulatedOrg != null));
};
